export default __webpack_public_path__ + "static/media/archmage-(i-l).39c2554e.png";